export class DashboardFilterService {
  constructor(data) {
    this.data = data;
  }

  getDashboardFilters() {
    return this.data.getDashboardFilters();
  }
}
